import React from 'react';
import { Link } from 'react-router-dom';
import { X, Phone } from 'lucide-react';
import { useBanner } from '../contexts/BannerContext';

export const TopBanner: React.FC = () => {
  const { isBannerVisible, setBannerVisible } = useBanner();

  const handleDismiss = () => {
    setBannerVisible(false);
  };

  if (!isBannerVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-white/90 dark:bg-gray-900/90 backdrop-blur-xl border-b border-gray-200 dark:border-blue-500/20 text-gray-900 dark:text-white py-2 sm:py-1 px-4 z-30 shadow-lg">
      
      <div className="max-w-7xl mx-auto flex items-center justify-between relative">
        {/* Compact attractive layout */}
        <div className="flex-1 flex items-center justify-center space-x-3 sm:space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-5 h-5 sm:w-6 sm:h-6 bg-blue-600 rounded-full flex items-center justify-center">
              <Phone className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" />
            </div>
            <span className="font-medium text-gray-900 dark:text-white text-xs sm:text-sm">
              <span className="sm:hidden">Free AI Consultation</span>
              <span className="hidden sm:inline">Complimentary AI Consultation Available</span>
            </span>
          </div>
          
          <Link
            to="/contact"
            className="inline-flex items-center px-3 py-1 sm:px-4 sm:py-1.5 bg-blue-600 text-white hover:bg-blue-700 rounded-full font-semibold text-xs sm:text-sm transition-all duration-200 hover:scale-105 group shadow-sm"
          >
            <span className="sm:hidden">Call</span>
            <span className="hidden sm:inline">Learn More</span>
            <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 ml-1 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
        
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors duration-200 ml-3"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4 text-gray-600 dark:text-gray-400" />
        </button>
      </div>
    </div>
  );
};